export const trackerArticleId = 30;
